import React, { Component } from 'react';
import classNames from 'classnames';
import { Redirect, Switch, Route } from 'react-router-dom';
import Header from '../components/Header/Header';
import Sprite from '../components/Sprite/Sprite';
import Footer from '../components/Footer/Footer';
import routes from '../routes';
import AuthConsumer from '../auth/AuthConsumer';
import Preloader from '../components/Preloader/Preloader';
import Error404 from './404/Error404';

export class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuActive: false
    };
  }

  toggleMenu = () => {
    this.setState({
      isMenuActive: !this.state.isMenuActive
    });
  };

  hideMenu = () => {
    this.setState({
      isMenuActive: false
    });
  };

  render() {
    const { isMenuActive } = this.state;

    return (
      <AuthConsumer>
        {({
          isLoading, userInfo, error, refreshAuth
        }) => {
          if (isLoading) {
            return <Preloader />;
          }
          if (error) {
            return <div>{`Error: ${error.message}`}</div>;
          }
          return !userInfo ? (
            <div>{/*  <Redirect to="/login" />  */}</div>
          ) : (
            <React.Fragment>
              <Sprite />
              <div className={classNames('layout', { 'menu-active': isMenuActive })}>
                <Header
                  location={this.props.location.pathname}
                  user={userInfo}
                  toggleMenu={this.toggleMenu}
                  hideMenu={this.hideMenu}
                />
                <main className="main">
                  <Switch>
                    {routes.advocates.map((route, idx) => (route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => <route.component {...props} user={userInfo} />}
                      />
                    ) : null))}
                    <Route component={Error404} />
                  </Switch>
                </main>
                <Footer />
              </div>
            </React.Fragment>
          );
        }}
      </AuthConsumer>
    );
  }
}
